{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              14.500179965987513,
              35.98148826933698
            ],
            [
              14.346221507791142,
              36.132864093962226
            ],
            [
              14.075757911275389,
              36.132863701657726
            ],
            [
              14.246361123073854,
              35.90063905959629
            ],
            [
              14.504341005397976,
              35.7386820234651
            ],
            [
              14.67494362123793,
              35.86355035363229
            ],
            [
              14.500179965987513,
              35.98148826933698
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}